export const en = {
    "Add": "Add {0}",
    "Edit": "Edit {0}"
}